module.exports = __webpack_public_path__ + "static/media/pic7@2x.9d2ee4d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_146/img/pic7@2x.png
// module id = 1400
// module chunks = 0